/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import AnalyticsService from 'cio/services/analytics';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import CustomFormsService from 'cio/services/custom-forms';

export default class FormsSuggestedProviders extends Component {
  @service analytics!: AnalyticsService;
  @service customForms!: CustomFormsService;

  typeformImage = new URL('cio/assets/images/integrations/typeform.svg', import.meta.url).toString();
  unbounceImage = new URL('cio/assets/images/integrations/unbounce.svg', import.meta.url).toString();
  jotformImage = new URL('cio/assets/images/integrations/jotform.svg', import.meta.url).toString();
  formstackImage = new URL('cio/assets/images/integrations/formstack.svg', import.meta.url).toString();
  instapageImage = new URL('cio/assets/images/integrations/instapage.svg', import.meta.url).toString();
  squarespaceImage = new URL('cio/assets/images/integrations/squarespace.svg', import.meta.url).toString();
  webflowImage = new URL('cio/assets/images/integrations/webflow.svg', import.meta.url).toString();
  netlifyImage = new URL('cio/assets/images/integrations/netlify.svg', import.meta.url).toString();
  wpformsImage = new URL('cio/assets/images/integrations/wpforms.svg', import.meta.url).toString();

  @action
  trackOpen() {
    this.analytics.track('forms', 'form_builders_viewed');
  }
}
